var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-linear',{attrs:{"color":_vm.data.postings[1],"height":"20"},model:{value:(_vm.data.postings[0]),callback:function ($$v) {_vm.$set(_vm.data.postings, 0, $$v)},expression:"data.postings[0]"}},[_c('strong',[_vm._v(_vm._s(_vm.data.postings[0])+"%")])])
}
var staticRenderFns = []

export { render, staticRenderFns }